import { NavMenuItem } from '../types/content';

/** Shared visibility rules for header, footer, and home sections. */
export function isNavMenuVisible(
  key: string,
  navItems: NavMenuItem[],
  flags?: { hasPublishedEvents?: boolean; hasPublishedGigs?: boolean }
): boolean {
  const item = navItems.find((n) => n.menuKey === key);
  // Labs & Interviews follow the admin Menus toggle, same as Courses (visible unless turned off).
  const adminVisible = item ? item.isVisible : true;
  if (key === 'idschool') return false;
  if (key === 'events') return !!flags?.hasPublishedEvents && adminVisible;
  if (key === 'gigs') return !!flags?.hasPublishedGigs && adminVisible;
  return adminVisible;
}

export function navMenuLabel(key: string, navItems: NavMenuItem[], fallback: string): string {
  return navItems.find((n) => n.menuKey === key)?.label || fallback;
}
